import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { NavigationMenu } from '../interface/config.interface';
import { UserService } from '../services/user.service';
import { take } from 'rxjs/operators';
import { LocalStorageService } from '../services/local-storage.service';
import { CommonService } from '../services/common.service';
import { EnvironmentService } from '../services/environment.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  @Output() navigationMenuAction: EventEmitter<NavigationMenu>;
  menuItems: NavigationMenu[] = [];
  selectedItem: number;
  showMenu: boolean;

  constructor(
    private router: Router,
    private userService: UserService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private environmentService: EnvironmentService
  ) {
    this.navigationMenuAction = new EventEmitter<NavigationMenu>();
  }

  ngOnInit(): void {
    this.selectedItem = -1;
    this.showMenu = false;
    this.userService.updateUserData.pipe(take(1)).subscribe(this.updateMenuItems.bind(this));
    this.transformMenu();
  }

  transformMenu(): void {
    this.showMenu = !this.showMenu;
    this.updateMenuItems();
    this.userService.isMenuOpen = this.showMenu;
  }

  selectMenuItem(id: number): void {
    const item = this.menuItems.filter(menu => menu.id === id)[0];
    if (item.label === 'logout') {
      this.navigationMenuAction.emit(item);
    } else {
      // this.localStorageService.removeItem('location_data');
      this.localStorageService.removeItem('personal_data');
      this.commonService.takeFromRequestOne = false;

      if (item.externalLink) {
        window.open(item.externalLink);
      } else {
        this.router.navigate([item.routerLink]);
      }
    }
    this.selectedItem = id;
  }

  private updateMenuItems(): void {
    const role: string = this.userService.getUserRole();
    const status: string = this.userService.getUserStatus();
    const menuData = this.environmentService.navigationMenu;

    if (role === null) {
      this.menuItems = [];
    } else {
      this.menuItems = menuData.filter(
        (menu: NavigationMenu) =>
          (menu.role.indexOf(role) !== -1 && menu.status.indexOf(status) !== -1) || (role === 'customer' && menu.id === 5)
      );
    }
  }
}
